const call = () => {
    return {
        copyToClipboard(inputId) {
            let $tb = document.getElementById(inputId)
            $tb.select();
            document.execCommand('copy');
        },
    };
};

export default call;